import { useEffect } from 'react';

import { SearchBar } from './SearchBar';

interface SearchOverlayProps {
  onClose: () => void;
}

export function SearchOverlay({ onClose }: SearchOverlayProps) {
  useEffect(() => {
    function handleEscape(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose();
      }
    }
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-wolisho-cream md:hidden">
      <SearchBar
        autoFocusOnMount
        onNavigate={onClose}
        resultsLayout="inline"
        className="flex-1"
        trailing={
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-2 text-sm font-medium text-white"
            aria-label="Close search"
          >
            Cancel
          </button>
        }
      />
    </div>
  );
}
